import * as $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
	const $item = $('.detailSummary');
	if (!$item) {
		return;
	}

	const className = 'detailSummary__heading';
	const selector_trigger = '.detailSummary__heading';
	const selector_target = '.detailSummary__content';
	
	// summary groups
	const summaryGroups = document.querySelectorAll('.detailSummaryGroup__wrapper');

	function formatHref(text: string): string {
		return text.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and');
	}

	function toggleItem(element: Element, force?: boolean): void {
		const $element = $(element);
		const isOpen = $element.parent().hasClass('target');

		if (isOpen) {
			$element.parent().removeClass('target');
			$element.next().stop(true).slideUp();
		} else {
			$element.parent().addClass('target');
			$element.next().stop(true).slideDown();
		}
	}

	function toggleItemTargeted(): void {
		const id = window.location.hash.replace(/([.:])/, '\\$1');
		const $targetedElement = $item.find(id);

		if ($targetedElement.hasClass(className)) {
			toggleItem($targetedElement.get(0)!);
		}
	}

	function toggleItemAll(): void {
		if (!window.location.hash) {
			const triggers = $item.find(selector_trigger);
			$item.find(selector_trigger).each((id) => {
				toggleItem(triggers.get(id)!);
			});
		}
	}

	// Used for groups with category headings - no attributes added if no category is added
	function setUpAttributes() {
		for (const group of summaryGroups) {
			// get group category name
			const headingName = group.querySelector('.detailSummaryGroup__heading')?.textContent!.trim();
			if (headingName) {
				// add the navigable IDs to each item
				for (const item of group.querySelectorAll('.detailSummary')) {
					const itemName = item.querySelector('h3')?.textContent!.trim()
						.replace(/\s+/g, '-').toLowerCase();
					if (itemName) {
						const sanitizedItemName = itemName.replace(/[^a-zA-Z0-9-]/g, ''); // Remove special characters
						const encodedItemName = encodeURIComponent(sanitizedItemName); // Encode for redirects

						item.setAttribute('id', `${formatHref(headingName)}:${encodedItemName}`);
					}
				}
			}
		}
	}
	  

	function setupIcons(): void {

let svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
	<path d="m20,0C8.95,0,0,8.95,0,20s8.95,20,20,20,20-8.95,20-20S31.05,0,20,0Zm0,36c-8.84,0-16-7.16-16-16S11.16,4,20,4s16,7.16,16,16-7.16,16-16,16Z"/>
	<path class="svg-path-v" d="m22,18v-4c0-1.1-.9-2-2-2s-2,.9-2,2v12c0,1.1.9,2,2,2s2-.9,2-2v-8Z"/>
	<path class="svg-path-h" d="m22,22h4c1.1,0,2-.9,2-2s-.9-2-2-2h-12c-1.1,0-2,.9-2,2s.9,2,2,2h8Z"/>
</svg>
`

		$(selector_trigger).append(svg);
	}

	function setupEventHandlers(): void {
		$item.on('click', selector_trigger, (event) => {
			event.preventDefault();
			// get the current location URL
			const url = new URL(location.toString());
			// clear the appended has if it exists
			url.hash = '';
			// get the parent wrapper with the ID
			// let currentElemParent: any = event.currentTarget.parentNode;
			let currentElemParent: any = event.currentTarget.closest('.detailSummary');
			// update the history so the link is shareable if group category field has been added
			if(summaryGroups.length > 0) {
				history.replaceState(undefined, '', url.toString() + `#${currentElemParent.id}`);
			}
			// toggle the clicked item
			toggleItem(event.currentTarget);
		});
	}

	// check summary blocks for 'hide header on mobile' option
	function addClassForHiddenHeaders() {
		// get all summary blocks
		for (const elem of document.querySelectorAll('.detailSummary')) {
			// if option is set to 'true', add the class to hide the heading
			if (elem.getAttribute('data-hide-heading-mobile') === 'true') {
				// check for heading inside content area, if it exists, add the 'hide on mobile' class
				elem.querySelector('.detailSummary__content')?.querySelector('h2, h3, h4')?.classList.add('hide-on-mobile');
			}
		}
	}

	setupIcons();
	setUpAttributes();
	setupEventHandlers();
	addClassForHiddenHeaders();
	$item.addClass('js-ready');

	const goo = () => {
		$item.find(selector_trigger).siblings(selector_target).slideUp(0);
	};
	$.when(goo()).done(() => {
		toggleItemTargeted();
		// toggleItemFirst();
		// toggleItemAll();
	});
});
